export default __webpack_public_path__ + "static/media/mechanic.ee8b8364.png";